import React from 'react';
import { motion } from 'framer-motion';
import { useAudioStore } from '@/hooks/useAudioStore';

const BAR_COUNT = 5;

export const WaveformVisualizer: React.FC = () => {
  const { isPlaying } = useAudioStore();

  return (
    <div className="flex items-end gap-1 h-6">
      {Array.from({ length: BAR_COUNT }).map((_, index) => (
        <motion.div
          key={index}
          animate={
            isPlaying
              ? {
                  height: ['20%', '100%', '40%', '80%', '20%'],
                }
              : { height: '30%' }
          }
          transition={{
            duration: 0.5 + index * 0.1,
            repeat: Infinity,
            repeatType: 'reverse',
            ease: 'easeInOut',
          }}
          className="w-1 bg-accent-cyan rounded-full"
        />
      ))}
    </div>
  );
};
